import { IPageRange } from '@aon/aon-tws-common-ui';
import { Reducer } from 'react';
import { IColumn, ISurveyListItem, IUserListItem } from '../models';
import * as UserListItemAPI from '../services/UserListItemAPI';
import * as SurveyAPI from '../services/SurveyAPI';
import { ISurveyCopyModalGetUserCount, ISurveyCopyModalGetUsersRequested, ISurveyCopyModalGetUsersSucceeded } from './Actions';
import { ActionTypes } from './ActionTypes';
import contentConstants from '../contentConstants';
import { IApplicationState } from '.';

export const defaultColumns: IColumn[] = [
	{
		displayText: 'Id',
		name: 'UserId',
		checked: true,
		displayOrder: 1,
		disabled: false,
		sortAscByDefault: true,
		isSortable: true,
	},
	{
		displayText: 'First Name',
		name: 'FirstName',
		checked: true,
		displayOrder: 2,
		disabled: false,
		sortAscByDefault: true,
		isSortable: true,
	},
	{
		displayText: 'Last Name',
		name: 'LastName',
		checked: true,
		displayOrder: 3,
		disabled: false,
		sortAscByDefault: true,
		isSortable: true,
	},
	{
		displayText: 'Email',
		name: 'Email',
		checked: true,
		displayOrder: 4,
		disabled: false,
		sortAscByDefault: false,
		isSortable: false,
	},
	{
		displayText: 'Status',
		name: 'Status',
		checked: true,
		displayOrder: 5,
		disabled: false,
		sortAscByDefault: true,
		isSortable: true,
	},
];

export interface ISurveyCopyModalState {
	users: IUserListItem[];
	isLoadingUsers: boolean;
	columns: IColumn[];
	userCount: number;
}

export const defaultState: ISurveyCopyModalState = {
	users: [],
	isLoadingUsers: false,
	columns: defaultColumns,
	userCount: 0,
};

export const ActionCreators = {
	GetUsersByClientId:
		(clientId: number, searchText: string, paging: IPageRange, sort: string) => (dispatch: any, getState: () => IApplicationState) => {
			dispatch({ type: ActionTypes.SURVEY_COPY_MODAL_GET_USERS_REQUESTED });
			return UserListItemAPI.getUsersByClientId(clientId, searchText, paging, sort).then((users: IUserListItem[]) => {
				const filteredUsers = users.filter((u) => u.status.toLowerCase() === 'initial' || u.status.toLowerCase() === 'active');
				const currentUser = getState().oidc.user;
				if (filteredUsers.findIndex((u) => u.userId === currentUser?.profile.external_userid) == -1) {
					filteredUsers.unshift({
						userId: currentUser?.profile.external_userid,
						firstName: 'me',
						lastName: '',
						email: 'me',
						status: 'Active',
					});
				}
				dispatch({ type: ActionTypes.SURVEY_COPY_MODAL_GET_USERS_SUCCEEDED, payload: filteredUsers });
			});
		},
	GetUserCountByClientId: (clientId: number, searchText: string) => (dispatch: any, getState: () => IApplicationState) => {
		return UserListItemAPI.getUserCountByClientId(clientId, searchText).then((users: IUserListItem[]) => {
			const filteredUsers = users.filter((u) => u.status.toLowerCase() === 'initial' || u.status.toLowerCase() === 'active');
			let userTotal = filteredUsers.length;
			const currentUser = getState().oidc.user;
			if (filteredUsers.findIndex((u) => u.userId === currentUser?.profile.external_userid) == -1) {
				userTotal++;
			}
			dispatch({ type: ActionTypes.SURVEY_COPY_MODAL_GET_USER_COUNT, payload: userTotal });
		});
	},
	BulkCopySurvey: (surveyId: number, userIds: number[]) => (dispatch: any) => {
		dispatch({ type: ActionTypes.TOAST_INFO_NOTIFICATION, payload: contentConstants.TOAST_BULK_COPY_SURVEYS_STARTED });
		return SurveyAPI.bulkCloneSurvey(surveyId, userIds).then((surveys: ISurveyListItem[]) => {
			dispatch({ type: ActionTypes.SURVEY_LIST_CLONE_SURVEY_SUCCEEDED, payload: surveys });
			dispatch({ type: ActionTypes.TOAST_INFO_NOTIFICATION, payload: contentConstants.TOAST_BULK_COPY_SURVEYS_FINISHED });
		});
	},
};

type KnownActions = ISurveyCopyModalGetUsersRequested | ISurveyCopyModalGetUsersSucceeded | ISurveyCopyModalGetUserCount;

export const reducer: Reducer<ISurveyCopyModalState, KnownActions> = (
	state: ISurveyCopyModalState = defaultState,
	action: KnownActions,
): ISurveyCopyModalState => {
	switch (action.type) {
		case ActionTypes.SURVEY_COPY_MODAL_GET_USERS_REQUESTED: {
			return { ...state, isLoadingUsers: true };
		}
		case ActionTypes.SURVEY_COPY_MODAL_GET_USERS_SUCCEEDED: {
			return { ...state, users: action.payload, isLoadingUsers: false };
		}
		case ActionTypes.SURVEY_COPY_MODAL_GET_USER_COUNT: {
			return { ...state, userCount: action.payload };
		}
		default:
			return { ...state };
	}
};
